import { useEffect, useState } from 'react';
import type { Pagination } from '@talentmesh/utils';
import PaginationConsts from '@/Utils/PaginationConsts';
import checkOutOfBound from './checkOutOfBound';

const usePagination = (initialLimit?: number): [Pagination, React.Dispatch<React.SetStateAction<Pagination>>] => {
    const [pagination, setPagination] = useState<Pagination>({
        offset: 0,
        limit: initialLimit ?? PaginationConsts.largePageSize,
        totalCount: 0,
    });

    useEffect(() => {
        const fixedPagination = checkOutOfBound(pagination);

        if (fixedPagination) {
            setPagination(fixedPagination);
        }
    }, [pagination, setPagination]);

    return [pagination, setPagination];
};

export default usePagination;
